module.exports = __webpack_public_path__ + "05858c0cf539422c30ea845731fcad89.png";